import type { SVGProps } from 'react'

import { CustomIconProps } from '@/shared/ui/icon-template'

export const MessageSvg = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M7.87819 5H36.6055V23.4545C36.6055 26.216 34.3669 28.4545 31.6055 28.4545H3.8782V9C3.8782 6.79086 5.66905 5 7.87819 5Z"
				fill="#4A4A4A"
			/>
			<path
				d="M11.9845 28.5166L12.6055 28.4545V5H7.33274C5.1236 5 3.33274 6.79086 3.33274 9V35L4.54294 33.0983C6.1896 30.5107 8.93263 28.8218 11.9845 28.5166Z"
				fill="url(#paint0_linear_19781_25217)"
			/>
			<path
				d="M30.4367 10.334C30.8966 10.334 31.2695 10.7069 31.2695 11.1668C31.2695 11.6268 30.8966 11.9997 30.4367 11.9997L18.769 11.9997C18.3091 11.9997 17.9362 11.6268 17.9362 11.1668C17.9362 10.7069 18.3091 10.334 18.769 10.334L30.4367 10.334Z"
				fill="white"
			/>
			<path
				d="M30.4367 15.332C30.8966 15.332 31.2695 15.7049 31.2695 16.1649C31.2695 16.6249 30.8966 16.9977 30.4367 16.9977L18.769 16.9977C18.3091 16.9977 17.9362 16.6249 17.9362 16.1649C17.9362 15.7049 18.3091 15.332 18.769 15.332L30.4367 15.332Z"
				fill="white"
			/>
			<path
				d="M25.4367 20.332C25.8966 20.332 26.2695 20.7049 26.2695 21.1649C26.2695 21.6249 25.8966 21.9977 25.4367 21.9977L18.7691 21.9977C18.3091 21.9977 17.9362 21.6249 17.9362 21.1649C17.9362 20.7049 18.3091 20.332 18.7691 20.332L25.4367 20.332Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_19781_25217"
					x1="7.96911"
					y1="5"
					x2="7.96911"
					y2="35"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#E4EDFC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
			</defs>
		</svg>
	)
}
